export default "__VITE_ASSET__C4JP_u2F__"